/*
 * Paski postępu sliderów (.hb-progress[data-slider-id]).
 * Aktualizacja tylko na zdarzenia (scroll / resize / load obrazków),
 * zamiast nieskończonych pętli requestAnimationFrame w każdej sekcji.
 */
(function () {
  if (window.__hbProgress) return;
  window.__hbProgress = true;

  var SELECTOR = '.hb-progress[data-slider-id]';

  function init(track) {
    if (track.dataset.hbInit === '1') return;
    var slider = document.getElementById(track.dataset.sliderId);
    if (!slider) return;
    track.dataset.hbInit = '1';

    var thumb = track.querySelector('.hb-progress-thumb');
    if (!thumb) {
      thumb = document.createElement('div');
      thumb.className = 'hb-progress-thumb';
      track.appendChild(thumb);
    }

    var last = null;
    var queued = false;

    function update() {
      queued = false;
      if (!track.clientWidth) return; // pasek ukryty (desktop / nieaktywny tab)
      var cw = slider.clientWidth;
      if (!cw) return;
      var sw = slider.scrollWidth;
      var pct = sw <= cw + 1
        ? 100
        : Math.min(100, Math.max(0, (slider.scrollLeft + cw) / sw * 100));
      pct = Math.round(pct * 10) / 10;
      if (pct !== last) {
        thumb.style.width = pct + '%';
        last = pct;
      }
    }

    // max 1 aktualizacja na klatkę i tylko wtedy, gdy coś się zmieniło
    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(update);
    }

    slider.addEventListener('scroll', schedule, { passive: true });
    slider.addEventListener('load', schedule, true); // load obrazków (capture - load nie bubbluje)
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(schedule); // odpala też przy pokazaniu taba
      ro.observe(slider);
      ro.observe(track);
    } else {
      window.addEventListener('resize', schedule);
    }
    schedule();
  }

  function scan(root) {
    if (root.matches && root.matches(SELECTOR)) init(root);
    if (root.querySelectorAll) root.querySelectorAll(SELECTOR).forEach(init);
  }

  scan(document);

  // Paski doładowane później (Section Rendering API, taby):
  // obserwujemy tylko sekcje, w których paski występują, nie cały <body>.
  var mo = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        if (nodes[j].nodeType === 1) scan(nodes[j]);
      }
    }
  });
  var observed = new Set();
  document.querySelectorAll(SELECTOR).forEach(function (el) {
    var s = el.closest('.shopify-section') || el.parentElement;
    if (s && !observed.has(s)) {
      observed.add(s);
      mo.observe(s, { childList: true, subtree: true });
    }
  });
})();
